export { default } from './discount';
